import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { MOCK_SPECIES } from '../data/mockSpecies';

export const SpeciesListPage: React.FC = () => {
    return (
        <div className="min-h-screen pt-24 pb-24 px-4 max-w-7xl mx-auto">
            <Link to="/wikipesca" className="inline-flex items-center gap-2 text-white/50 hover:text-white transition-colors font-bold uppercase tracking-widest text-xs mb-8">
                <ArrowLeft size={16} /> Voltar
            </Link>
            <h1 className="text-4xl font-display font-black text-white uppercase mb-8">Espécies de Peixes</h1>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                {MOCK_SPECIES.map(species => (
                    <Link key={species.id} to={`/wikipesca/peixes/${species.slug}`} className="bg-white/5 border border-white/10 rounded-2xl p-4 hover:bg-white/10 transition-colors group">
                        <div className="aspect-square bg-black/40 rounded-xl mb-4 overflow-hidden relative">
                             <img src={species.coverImage} alt={species.commonNames[0]} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                             <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent opacity-60"></div>
                             {species.difficulty === 'expert' && <span className="absolute top-2 right-2 bg-purple-500 text-[10px] font-bold px-2 py-0.5 rounded text-white uppercase">Expert</span>}
                        </div>
                        <h3 className="text-white font-bold text-lg">{species.commonNames[0]}</h3>
                        <p className="text-white/40 text-xs italic mb-2">{species.scientificName}</p>
                        <p className="text-white/60 text-xs line-clamp-2">{species.shortDescription}</p>
                    </Link>
                ))}
            </div>
        </div>
    );
};
